module.exports = __webpack_public_path__ + "static/media/smp.2d429b3c.svg";